export default "__VITE_ASSET__Bd6pMA8K__"